import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsClientsTabsTabVoluntaryProgramActivity from 'components/form-fields-clients-tabs/tab-voluntary-program-activity/tab-voluntary-program-activity';
class EditViewClientTabVoluntaryProgramActivity extends Component {
  render() {
    return (
      <div>
        <FormFieldsClientsTabsTabVoluntaryProgramActivity {...this.props} locked={this.props.locked} />
      </div>
    );
  }
}
EditViewClientTabVoluntaryProgramActivity.propTypes = {
  locked: PropTypes.bool,
}
EditViewClientTabVoluntaryProgramActivity = reduxForm({
  form: 'ClientEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewClientTabVoluntaryProgramActivity);
export default EditViewClientTabVoluntaryProgramActivity;